// extracted by mini-css-extract-plugin
module.exports = {"asset":"Asset-module__asset___2_6sw","video":"Asset-module__video___3JNxl"};